import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const SearchViewportContext = createContext({ viewport: null, publish: () => {} });

export const SearchViewportProvider = ({ children }) => {
  const { pathname } = useLocation();
  const [state, setState] = useState(null);
  const publish = useCallback((viewport) => setState({ pathname, viewport }), [pathname]);
  return (
    <SearchViewportContext.Provider value={{
      viewport: state?.pathname === pathname ? state.viewport : null, publish,
    }}>
      {children}
    </SearchViewportContext.Provider>
  );
};

export const useSearchViewport = () => useContext(SearchViewportContext).viewport;

export const usePublishSearchViewport = (viewport) => {
  const { publish } = useContext(SearchViewportContext);
  useEffect(() => {
    publish(viewport);
    return () => publish(null);
  }, [viewport, publish]);
};
